/**
 * Whether to label a class session with its remaining-spots count.
 *
 * Per class template: some venues read "4 spots left" as urgency, others as a
 * half-empty room. `class_types.show_spots_remaining` defaults to true, so a
 * tenant that never touches the setting keeps the count; the nested
 * `class_types.show_spots_remaining_last_only` (default false) keeps the count
 * hidden until a session is down to its last spot, so small classes get
 * "1 spot left" urgency without ever advertising an empty room. Callers pass
 * the flags straight through from the row; both are optional so a surface that
 * hasn't been wired up yet still shows the count rather than silently hiding it.
 *
 * The Full / Waitlist states are NOT gated by this — a full session must say so
 * regardless, otherwise a customer taps into a class they can't join.
 */
export function shouldShowSpotsLeft({
  spotsRemaining,
  showSpotsRemaining = true,
  lastSpotOnly = false,
}: {
  spotsRemaining: number;
  /** class_types.show_spots_remaining — omitted means show (the DB default). */
  showSpotsRemaining?: boolean;
  /** class_types.show_spots_remaining_last_only — omitted means always show (the DB default). */
  lastSpotOnly?: boolean;
}) {
  if (!showSpotsRemaining || spotsRemaining <= 0) {
    return false;
  }

  return lastSpotOnly ? spotsRemaining <= 1 : true;
}
